import actions from '@/core/store/item-ata/alterar-fornecedor/alterar/actions'
import state from '@/core/store/item-ata/alterar-fornecedor/alterar/state'
import mutations from '@/core/store/item-ata/alterar-fornecedor/alterar/mutations'

export default { actions, state, mutations }
